import ApiInfo from './ApiInfo.js';

class AuditApiInfo extends ApiInfo {
    constructor ({
        path,
        type = 'get',
        timeout,
        headers,
        project = 'audit', // || qukan,
        author = '未定义'
    }) {
        super({
            path,
            type,
            timeout,
            headers,
            project,
            author
        });
    }
}

export default {
    // 文章复审
    contentreviewaudit: {
        list: new AuditApiInfo({
            path: '/audit/contentreviewaudit/list',
            type: 'get',
            author: '张敏05'
        }),
        audit: new AuditApiInfo({
            path: '/audit/contentreviewaudit/audit',
            type: 'get',
            author: '张敏05'
        }),
        view: new AuditApiInfo({
            path: '/audit/contentreviewaudit/view',
            type: 'get',
            author: '张敏05'
        }),
        exitaudit: new AuditApiInfo({
            path: '/audit/contentreviewaudit/exitaudit',
            type: 'get',
            author: '张敏05'
        }),
        statistics: new AuditApiInfo({
            path: '/audit/contentreviewaudit/statistics',
            type: 'get',
            author: '张敏05'
        }),
        config: new AuditApiInfo({
            path: '/audit/contentreviewaudit/reasonList',
            type: 'get',
            author: '李洪城'
        })
    },
    contentauditwhite: {
        list: new AuditApiInfo({
            path: '/audit/contentauditwhite/list',
            type: 'get',
            author: '张敏05'
        }),
        add: new AuditApiInfo({
            path: '/audit/contentauditwhite/add',
            type: 'get',
            author: '张敏05'
        }),
        delete: new AuditApiInfo({
            path: '/audit/contentauditwhite/delete',
            type: 'get',
            author: '张敏05'
        })
    },
    policy: {
        run: new AuditApiInfo({
            path: '/policy/policy/run',
            type: 'POST',
            author: '张敏05'
        })
    },

    // 用户文章初审
    contentAudit: {
        view: new AuditApiInfo({
            path: '/audit/contentAudit/view',
            type: 'post',
            author: '李洪城'
        }),
        audit: new AuditApiInfo({
            path: '/audit/contentAudit/audit',
            type: 'post',
            author: '张敏05'
        }),
        // 列表
        list: new AuditApiInfo({
            path: '/audit/contentAudit/list',
            type: 'post',
            author: '张敏05'
        }),
        // 退出
        exitView: new AuditApiInfo({
            path: '/audit/contentAudit/exitAudit',
            type: 'post',
            author: '张敏05'
        }),
        // 稿件状况
        statistics: new AuditApiInfo({
            path: '/audit/contentAudit/statistics',
            type: 'post',
            author: '张敏05'
        }),
        getAuditReason: new AuditApiInfo({
            path: '/audit/UserArticleAudit/getAuditReason',
            type: 'post',
            author: '王飞mvp'
        }),
        // 图文聚合分类
        getMergeCategory: new AuditApiInfo({
            path: '/audit/userarticleinfo/getMergeCategory',
            type: 'post',
            author: '张敏'
        }),
        // 图文分类
        getNewCategory: new AuditApiInfo({
            path: '/audit/userarticleinfo/getNewCategory',
            type: 'post',
            author: '张敏'
        })
    },
    // 用户文章复审
    contentReview: {
        view: new AuditApiInfo({
            path: '/audit/UserArticleReview/view',
            type: 'get',
            author: '聂元培'
        }),
        audit: new AuditApiInfo({
            path: '/audit/UserArticleReview/audit',
            type: 'post',
            author: '聂元培'
        }),
        list: new AuditApiInfo({
            path: '/audit/UserArticleReview/list',
            type: 'get',
            author: '李洪城'
        }),
        statistics: new AuditApiInfo({
            path: '/audit/userarticlereview/statistics',
            type: 'get',
            author: '李洪城'
        }),
        exitView: new AuditApiInfo({
            path: '/audit/UserArticleReview/exitView',
            type: 'post',
            author: '李洪城'
        })
    }
};
